import { createContext } from "react";

export const OfertaViewContext = createContext();

